import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=785a592e&"
import script from "./Docs.vue?vue&type=script&lang=js&"
export * from "./Docs.vue?vue&type=script&lang=js&"
import style0 from "./Docs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n/main.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2Fviews%2FDocs.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "../i18n/docs.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2Fviews%2FDocs.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "../i18n/doc.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2Fviews%2FDocs.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports